import basicAppConfig from "@next-platform/client-common-core/infra/constants/basicAppConfig";
import { Text, TextVariants } from "@next-platform/client-common-spicy-ui";

import { LocalizedLink } from "@/components/LocalizedLink/LocalizedLink";
import { EXTERNAL_ROUTES_FOR_APPLICATION } from "@/constants";

type TtsGuideLinkProps = {
  label: string;
  ariaLabel: string;
  className?: string;
  navigationKey?: "tts_docs" | "custom_voices_docs";
};

export default function TtsGuideLink({ label, ariaLabel, className = "flex items-center text-link", navigationKey = "tts_docs" }: TtsGuideLinkProps) {
  const applicationId = basicAppConfig.applicationId;
  const externalRoutes = EXTERNAL_ROUTES_FOR_APPLICATION[applicationId as keyof typeof EXTERNAL_ROUTES_FOR_APPLICATION];
  const ttsDocsUrl = externalRoutes?.[navigationKey];

  if (!ttsDocsUrl) {
    return null;
  }

  return (
    <LocalizedLink className={className} target="_blank" to={ttsDocsUrl} aria-label={ariaLabel}>
      <Text variant={TextVariants.LABEL_MEDIUM_REGULAR}>{label}</Text>
    </LocalizedLink>
  );
}
